import util from '@/libs/util'

const post = util.ajax.post

export const materialUrls = [
  // 查询
  '/serviceMaterial/list'
]

export const material = {}

material.list = function (params) {
  return post('/material/fuzzysearchname', params)
}
material.listByIds = function (params) {
  return post('material/getmaterialsbyids', params)
}
material.selectbyid = function (params) {
  return post('/material/getbyid', params)
}
material.add = function (params) {
  return post('/material/add', params)
}
material.delete = function (params) {
  return post('/material/delete', params)
}
material.update = function (params) {
  return post('/material/update', params)
}
material.getByName = function (parmrs) {
  return post('/material/getbyname', parmrs)
}
material.updateStatus = function (params) {
  return post('/material/updateStatus', params)
}



// WEBPACK FOOTER //
// ./src/api/gip/service/material.js